import ArrowForwardRounded from '@mui/icons-material/ArrowForwardRounded';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import PolarisInterviews from 'src/PolarisInterviews';
import { PreviewContainer } from '../styles';
import StatsAndStatus from './StatsAndStatus';

import type {
  IInterviewConfig,
  IPolarisInterviewsProps,
  MiniInterviewType,
} from 'src/packages/polaris/types';
import type { RefObject } from 'react';

interface IProps {
  interview: IPolarisInterviewsProps & {
    question: string;
    interview: MiniInterviewType;
    id: string;
  };
  firstInterviewConfigAdjusted?: IInterviewConfig[];
  firstInterviewParentId?: string;
  shouldShowPreview?: boolean;
  onClick: (id: string) => void;
  innerRef?: RefObject<HTMLDivElement>;
}

const InterviewPreviewCard = ({
  interview,
  onClick,
  firstInterviewConfigAdjusted,
  firstInterviewParentId,
  shouldShowPreview,
  innerRef,
}: IProps) => {
  const handleInterviewClick = () => {
    onClick(interview.configs[0].id);
  };

  return (
    <Grid item key={interview.id} className="bp-my-1 bp-w-full">
      <Card
        onClick={handleInterviewClick}
        className="bp-flex-col bp-rounded-lg !bp-bg-teal-0 bp-text-left bp-font-primary hover:!bp-bg-teal-10"
        elevation={0}
      >
        <CardActionArea>
          <CardContent className="bp-px-4 bp-py-3">
            <div className="bp-flex bp-w-full bp-items-center bp-justify-between bp-normal-case bp-text-gray-100">
              <span className="bp-flex bp-flex-col bp-justify-start bp-pr-6 bp-align-top bp-text-gray-100">
                <span className="bp-text-lg bp-leading-tight" ref={innerRef}>
                  {interview.question}
                </span>
                <StatsAndStatus
                  interviewConfigs={interview.configs}
                  interviewType={interview.interview}
                />
              </span>
              {!shouldShowPreview && <ArrowForwardRounded fontSize="small" color="inherit" />}
            </div>
          </CardContent>
          {shouldShowPreview && firstInterviewConfigAdjusted && (
            <div className="bp-rounded-b-lg bp-border bp-border-solid bp-border-teal-10 bp-bg-white">
              <PreviewContainer>
                <PolarisInterviews
                  configs={firstInterviewConfigAdjusted}
                  parentInterviewId={firstInterviewParentId}
                />
              </PreviewContainer>
            </div>
          )}
        </CardActionArea>
      </Card>
    </Grid>
  );
};

export default InterviewPreviewCard;
